import { Component, ViewChild } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { SideContentColumnComponent } from './shared/components/side-content-column/side-content-column.component';
import { filter } from 'rxjs/operators';
import { ToastComponent } from './components/toast/toast.component';
import { ToastService } from './services/toast.service';
import { MetaPixelService } from './services/meta-pixel.service';
import { ViewportScroller } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { AuthService } from './auth/services/auth.service';
import { AuthFlowService } from './auth/services/auth-flow.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    SidebarComponent,
    SideContentColumnComponent,
    ToastModule
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'authoritie';
  isAuthRoute = false;
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;

  get toastPosition(): 'top-center' | 'top-right' {
    return window.innerWidth < 768 ? 'top-center' : 'top-right';
  }

  toastBreakpoints = {
    '768px': { width: '90%', right: '0', left: '50%', transform: 'translateX(-50%)' }
  };

  constructor(
    private router: Router,
    private toastService: ToastService,
    private metaPixelService: MetaPixelService,
    private viewportScroller: ViewportScroller,
    private authService: AuthService,
    private authFlowService: AuthFlowService
  ) {
    // Check if user is authenticated and redirect to appropriate step
    if (this.authService.isAuthenticated()) {
      // Only redirect if we're on the root or login page to avoid interfering with guards
      const currentUrl = this.router.url;
      if (currentUrl === '/' || currentUrl === '/auth/login' || currentUrl === '/auth') {
        // this.authFlowService.redirectToAppropriateRoute();
      }
    }

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isAuthRoute = event.url.startsWith('/auth');
        // Scroll to top on route change
        if (document.querySelector('#app-layout') != null) {
          document.querySelector('#app-layout')?.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.viewportScroller.scrollToPosition([0, 0]);
        
        // Track page view with Meta Pixel
        this.metaPixelService.trackPageView();
        
        // Refresh user profile from /me endpoint on each screen load
        // Skip for public auth routes that don't require authentication
        const publicAuthRoutes = ['/auth/login', '/auth/register', '/auth/reset-password', '/auth/forgot-password', '/auth/facebook-callback', '/auth/verify'];
        if (this.authService.isAuthenticated() && !publicAuthRoutes.some(route => event.url.startsWith(route))) {
          this.refreshUserProfile();
        }
      }
    });
  }

  ngAfterViewInit() {
    this.toastService.register(this.toastComponent);
  }

  /**
   * Refresh user profile from /me endpoint (non-blocking)
   * Updates service and localStorage with latest user data
   */
  private refreshUserProfile(): void {
    this.authService.getUserProfile().subscribe({
      next: (response: any) => {
        const profile = response?.data || response;
        // Update localStorage with fresh data
        localStorage.setItem('user', JSON.stringify(profile));
        // Update service with fresh data
        this.authService.currentUserSubject.next(profile);
      },
      error: (error) => {
        console.error('App Component - Error refreshing user profile:', error);
        // Don't block navigation on error, continue with cached data
      }
    });
  }
}
